<template>
  <v-list>
    <v-list-item
      v-for="{ value, text, property } in items"
      :key="`${property}-${value}`"
      @click="emitFilter(property, value)"
    >
      <v-list-item-title>
        {{ text }}
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'SelectFilterList',
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    emitFilter(property, value) {
      this.$emit('filter', { property, value });
    },
  },
};
</script>

<style scoped>
  div.v-list-item:hover{
    background: #ccc;
    cursor: pointer;
  }
</style>
